import React, { useState, useContext} from 'react';
import {Link} from 'react-router-dom';
import Map from "../Map";
import Header from '../../../../layout/Header/index';
import { ContextHotel} from '../../../../contexts/Hotels'
function HotelLists({ hotels, destinations }) {
  const key = "AIzaSyAwUUGIMXTOZEX_rtcZj1IyvTOqsA2sts4";

  const [hoverMap, sethoverMap] = useState("");
  const { hotelContext, onClickId } = useContext(ContextHotel);

  const HoverMap = item => {
    sethoverMap(item)
  }
  

  return (
    <div className="hotel">
      <div className="row">
        <div className="col-lg-6 col-12 col-md-6">
          <div className="map">
            <Map
              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap`}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={
                <div
                  style={{
                    height: `100%`,
                    margin: `auto`,
                  }}
                />
              }
              hoverMap={hoverMap}
              hotels={hotels}
              destinations={destinations}
              
              mapElement={<div style={{ height: `100%` }} />}
            />
          </div>
        </div>
        <div className="col-lg-6 col-12 col-md-6 ">
          <div className="hotelList">
            <div className="row formRow">
              {hotels
                .filter(
                  (hotel) =>
                    destinations == "" ||
                    destinations == null ||
                    hotel.destination_id == destinations
                )
                .map((item, image, name, as, id, address) => {
                  return (
                    <div
                      className={
                        destinations
                          ? "col-lg-12 col-8 col-md-12 formCol"
                          : "col-lg-6 col-8 col-md-12 formCol"
                      }
                      key={(image, name, as, id, address) }
                    >
                      <div className="itemBox" onMouseEnter={item => HoverMap(item.destination_id)}>
                        <Link  to={`/hotel/${item.id}`}>
                          <div className="image">
                            <img
                              className="img-fluid"
                              src={item.image}
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="title">{item.name}</h5>
                            <div className="address">
                              <img
                                className="img-fluid"
                                src="/images/location.png"
                                alt=""
                              />
                              {item.address}
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default HotelLists